import { atom } from "jotai";

export const appLayoutSidebarCollapsedAtom = atom(false);
